export default __webpack_public_path__ + "static/media/grey-check.702cd134.svg";